/**
 * Created by r4zi4l on 04.07.2022
 */

OrderIcon.prototype.updateIngredients = function () {

};

OrderIcon.prototype.updateButton = function () { 

};

OrderIcon.prototype.updateRewards = function () {
    if (!this.maker.recipe || this.rewards) {
        return;
    }

    const styles = cleverapps.styles.OrderIcon.rewards;
    const units = {};

    this.maker.recipe.order.forEach((item) => {
        const key = Unit.GetKey(item.unit);

        if (!units[key]) {
            units[key] = 0;
        }

        units[key] += 1;
    });

    const keys = Object.keys(units);

    const pairs = keys.map((key) => {
        const unit = Unit.ParseKey(key);
        const image = UnitView.getUnitImage(unit, { preferStatic: true });
        const text = cleverapps.UI.generateImageText(`x${units[key]}`, cleverapps.styles.FONTS.ORDERICON_AMOUNT_TEXT);

        return new cleverapps.Layout([image, text], {
            direction: cleverapps.UI.HORIZONTAL
        });
    });

    const provider = this.maker.unit.components.find((component) => component.getOrderRewards);
    if (provider && provider.getOrderRewards()) {
        new RewardsList(provider.getOrderRewards(), { event: cleverapps.EVENTS.EARN.OTHER }).listRewards().forEach((reward) => {
            const image = reward.getIcon();
            const text = cleverapps.UI.generateImageText(`x${reward.getAmount()}`, cleverapps.styles.FONTS.ORDERICON_AMOUNT_TEXT);

            pairs.push(new cleverapps.Layout([image, text], {
                direction: cleverapps.UI.HORIZONTAL
            }));
        });
    }

    if (pairs.length >= 3) {
        const rows = [];
        for (let i = 0; i < pairs.length; i += 2) {
            rows.push(new cleverapps.Layout(pairs.slice(i, i + 2), {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.pairMargin.x
            }));
        }

        this.rewards = new cleverapps.Layout(rows, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.pairMargin.y
        });
    } else {
        this.rewards = new cleverapps.Layout(pairs, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin.y
        });
    }
    this.rewards.setAlignment(styles);
    this.rewards.setCascadeOpacityEnabledRecursively(true);
    this.unitsLayer.addChild(this.rewards);

    cleverapps.UI.fitToBox(this.rewards, {
        width: styles.width,
        height: styles.height
    });

    this.rewards.setOpacity(0);
    this.rewards.runAction(new cc.Sequence(
        new cc.DelayTime(0.1),
        new cc.FadeIn(0.2)
    ));
};

OrderIcon.prototype.updateSelection = function (maker) {
    const isHungry = this.maker.unit.findComponent(HungryGamesCustomer);

    if (this.maker === maker) {
        this.background.setSpriteFrame(isHungry ? bundles.ordericon.frames.order_sheet_hungry : bundles.ordericon.frames.order_sheet_selected);

        if (this.clickHandler) {
            this.clickHandler.remove();
            delete this.clickHandler;

            this.hoverHandler.remove();
            delete this.hoverHandler;
        }
    } else {
        this.background.setSpriteFrame(isHungry ? bundles.ordericon.frames.order_sheet_hungry : bundles.ordericon.frames.order_sheet);

        if (!this.clickHandler) {
            this.clickHandler = cleverapps.UI.onClick(this, () => {
                cleverapps.effects.fire("ui.button.click");
                this.orders.selectMaker(this.maker);
            });

            this.hoverHandler = cleverapps.UI.applyHover(this);
        }
    }
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ORDERICON_TIMER_TEXT: {
        name: "default",
        size: 28,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.overrideStyles(cleverapps.styles.OrderIcon, {
    width: 260,
    height: 300,
    rotation: -3,

    pin: {
        x: { align: "left", dx: 0 },
        y: { align: "top", dy: 4 },
        icon: {
            x: { align: "center" },
            y: { align: "center", dy: 25 }
        }
    },

    tape: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: 10 }
    },

    timer: {
        x: { align: "left", dx: -14 },
        y: { align: "top", dy: 2 },
        width: 260,

        background: {
            x: { align: "left", dx: 14 },
            y: { align: "center", dy: -5 },
            width: 260
        }
    },

    rewards: {
        x: { align: "center", dx: -5 },
        y: { align: "center", dy: -20 },
        width: 210,
        height: 200,

        pairMargin: {
            x: 15,
            y: 15
        },

        margin: {
            x: 0,
            y: 15
        }
    }
});
